import { addLog } from 'assets/components/feedback/Feedback';
import ModalForm from 'assets/components/form/modalForm/ModalForm';
import ThemeModalFormDefault from 'assets/components/form/modalForm/themes/Theme.ModalForm.Default';
import Icon from 'assets/components/icon/Icon';
import SelectInput from 'assets/components/inputs/select/SelectInput';
import TextInput from 'assets/components/inputs/text/TextInput';
import FormWrapper from 'assets/components/inputs/wrappers/FormWrapper';
import { getLocales } from 'assets/locales/Locale';
import { isEmail } from 'assets/utils/parsersAndValidation/Validators';
import { HttpStatus } from 'config/Api.Config';
import { values } from 'lodash';
import ContractConsentRequestType from 'models/enums/ContractConsentRequestType';
import contractConsentResendApi from 'models/sales/contractConsent/resend/Api.ContractConsent.Resend';
import { SalesContractAction, useSalesContractProvider } from '../../Sales.Contract.Hooks';

export type ContractResendConsentForm = Api.Core.ContractConsent.Resend.IParams &
  Api.Core.ContractConsent.Resend.IRequest;
const ContractResendConsent = () => {
  const { lang } = getLocales();
  const { selected, findApi, listApi, pageRouter } = useSalesContractProvider();

  return (
    <ModalForm<ContractResendConsentForm>
      subcomponents={ThemeModalFormDefault}
      dependencyArray={[selected]}
      title={lang.resendConsent}
      default={{
        id: selected?.contractConsentId ?? selected?.contractConsent?.id,
        requestType: ContractConsentRequestType.EMAIL,
        customerEmail: selected?.contractConsent?.customerEmail,
      }}
      onCancel={() => pageRouter.updateParams({ id: selected?.id?.toString(), action: SalesContractAction.INFO })}
      onSubmit={async ({ id, requestType, customerEmail }) => {
        const res = await contractConsentResendApi({ id, requestType }, { customerEmail });
        if (res.status !== HttpStatus.ok) addLog({ error: res.message });
        else {
          addLog({ success: lang.saveSuccess });
          pageRouter.updateParams({ id: selected.id.toString(), action: SalesContractAction.INFO });
          listApi.execute((body) => body);
          findApi.execute((body) => body);
        }
      }}
      validation={(data, errors) => {
        if (!data.requestType) errors.requestType = lang.required;
        if (!data.customerEmail) errors.customerEmail = lang.required;
        if (data.customerEmail && !isEmail(data.customerEmail))
          errors.customerEmail = lang.invalidFormatRequires.replace('{format}', 'example@example.com');
      }}
      render={({ form }) => (
        <FormWrapper>
          <SelectInput
            name="requestType"
            data={values(ContractConsentRequestType).map((it) => ({
              id: it,
              title: it.toUpperCase(),
            }))}
            disabled={true}
            value={form.data?.requestType}
            onChange={form.update}
            error={form.errors.requestType}
            label={lang.type}
            icon={<Icon class="fas-envelope" />}
          />
          <TextInput
            name="customerEmail"
            label={lang.email}
            value={form.data?.customerEmail}
            error={form.errors.customerEmail}
            onChange={form.update}
            icon={<Icon class="if-quill-pen" />}
          />
        </FormWrapper>
      )}
    />
  );
};

export default ContractResendConsent;
